import { render } from "./Sender.vue?vue&type=template&id=7f52179c&scoped=true"
import script from "./Sender.vue?vue&type=script&lang=js"
export * from "./Sender.vue?vue&type=script&lang=js"

import "./Sender.vue?vue&type=style&index=0&id=7f52179c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f52179c"]])

export default __exports__